import { render, staticRenderFns } from "./UpdateConfirm.vue?vue&type=template&id=e4c8bdda&"
import script from "./UpdateConfirm.vue?vue&type=script&lang=ts&"
export * from "./UpdateConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports